export default {
  methods: {
    /**
     * The standard method for focusing the input field. Individual components
     * may override this method and provide their own (like RfMultiple)
     */
    focus () {
      this.$nextTick(function () {
        this.$refs.input && this.$refs.input.focus()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/focus.js